import script from "./picture-single-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./picture-single-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__